function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.79 8.768L6.04 5.01l3.728-3.704a.708.708 0 000-1.008.724.724 0 00-1.016 0L5.028 3.998 1.248.212a.716.716 0 00-1.016 0 .725.725 0 000 1.02l3.773 3.781L.21 8.783a.71.71 0 000 1.008.723.723 0 001.018 0l3.79-3.765 3.756 3.762a.716.716 0 001.016 0 .724.724 0 000-1.02z",
  fill: "gray",
  fillRule: "nonzero"
});

function SvgFeatureClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFeatureClose;